<template>
    <div>
        <vs-checkbox class="w-full" v-model="enabled"> Habilitar estoque para este produto </vs-checkbox>
        <!-- <vs-input v-model.number="quantity" :disabled="!enabled" label="Quantidade" class="mt-4" /> -->
        <div class="w-full mt-4 pl-2">
            <span> Quantidade </span>
        </div>
        <div class="w-full pl-2">
            <a-input-number  
                class="w-full md:w-2/12 lg:w-2/12 xl:w-2/12"
                size="large" 
                :min="0" 
                :default-value="1" 
                v-model="quantity" 
                :disabled="!enabled" />
        </div>
        <a-alert  
            message="Lembre-se" 
            description="Quando a quantidade do estoque chegar a zero, o produto será desabilitado automaticamente." 
            type="info" 
            show-icon 
            class="mt-6 ml-2" />
    </div>
</template>

<script>
    import { mapMutations, mapState } from 'vuex'

    export default {
        computed : {
            enabled : {
                get () {
                    return this.productInfo.stock && this.productInfo.stock.enabled
                },
                set (enabled) {
                    this.setStockEnabled(enabled)
                }
            },
            quantity : {
                get () {
                    return (this.productInfo.stock && this.productInfo.stock.hasOwnProperty('quantity')) ? this.productInfo.stock.quantity : 1
                },
                set (quantity) {
                    this.setStockQuantity(quantity)
                }
            },
            ...mapState('product', ['productInfo'])
        },

        methods : {
            ...mapMutations('product', ['setStockQuantity', 'setStockEnabled'])
        }
    }
</script>